import { ProviderTuple } from "../interfaces/propsProvider"
import { ProvidersCompose } from "../provider"

import { Provider as ReduxProvider } from "react-redux"
import store from "../store"

import { ModalEstadoProvider } from "../contexts/ModalEstado"

const providers: ProviderTuple [] = [
    [ ModalEstadoProvider, {} ],
    [ ReduxProvider, { store } ]
]

export const AppProvider = ProvidersCompose(providers)